const sendBeacon = (url: string, data: Record<string, any>) => {
  const blob = new Blob([JSON.stringify(data)], {
    type: 'application/json',
  });

  if (navigator.sendBeacon) {
    navigator.sendBeacon(`${process.env.API_HOST}/${url}`, blob);
  } else {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${process.env.API_HOST}/${url}`, false);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(blob);
  }
};

export default sendBeacon;
